/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A form on a person's page: filled out, waiting or expired.
 */
export type PersonFormRow = {
  form_id: number;
  form_name: string;
  status: PersonFormRow.status;
  date: string;
  response_id?: number | null;
  filled_by?: string | null;
};

export namespace PersonFormRow {
  export enum status {
    FILLED_OUT = "filled_out",
    CONFIRMED = "confirmed",
    WAITING = "waiting",
    EXPIRED = "expired",
  }
}
